export default class ProductHistoryCompany {
	name: string;

	constructor(name: string) {
		this.name = name;
	}
}
